import React, { useEffect, useRef, useState } from 'react';
import { getPCItems } from '../services/userservice';
import { gaEvent } from '../utils/GoogleAnalytics/gatracking';
import ListDisplay from '../components/ListDisplay/ListDisplay';
import { showCategoriesCities } from '../services/dwhservices';
import { useGlobalContext } from '../SearchBar/SearchBar';
import { useDwhAppContext } from '../context/DwhContextProvider';

// Module-level: survives unmount/remount on tab switches, keyed by glid.
const _paidCategoriesCache = new Map(); // glid → { mcat, cities }
const _freeCategoriesCache = new Map(); // glid → { productList, count }

const TopCategories = ({ empid,glid, ak, topProductsCount, topProductsList, selectedTab }) => {

  const [productList, setProductList] = useState("");
  const { paidFree } = useGlobalContext();
  const { topMcatsCities, setTopMcatsCities } = useDwhAppContext();

  const fetchedGlid = useRef(null);         // in-flight guard for Paid path
  const fetchedProductGlid = useRef(null);  // in-flight guard for Free path

  const topProducts = async (glid) => {
    try {
      const res = await getPCItems(glid, ak);
      const count = res?.data?.length ?? 0;
      topProductsCount(count);
      if (count) {
        const names = res.data.slice(0, 6).map(p => p['ITEM_NAME']);
        const list = names.join(',   ');
        _freeCategoriesCache.set(glid, { productList: list, count });
        setProductList(list);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const redirectWeberpDIRIMPage = () => {
    gaEvent("Seller Top Products", "Top Products", "click", "Top Products", glid);
    window.open(`https://weberp.intermesh.net/Company/Dir_IMListing.aspx?GLID=${glid}&source=sts`, '_new');
  };

  const displayCategoriesCities = async (rptFlag, isSecondAPI = false) => {
    try {
      const res = await showCategoriesCities(glid,empid,ak, rptFlag);
      if (res?.data?.status_code === 200) {
        const parsedData = JSON.parse(res?.data?.response);
        const sortKey = isSecondAPI ? "total_bl_pur" : "bl_pur_cnt";
        const filteredData = parsedData?.res.filter(item =>
          sortKey === "bl_pur_cnt" ? item.glcat_mcat_name?.toLowerCase() !== "others" : true
        );
        const sortedData = filteredData
          .sort((a, b) => (b[sortKey] || 0) - (a[sortKey] || 0))
          .slice(0, 10);
        return sortedData;
      }
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  useEffect(() => {
    if (!glid || !paidFree) return;

    if (paidFree === "Paid | ") {
      if (_paidCategoriesCache.has(glid)) {
        const { mcat, cities } = _paidCategoriesCache.get(glid);
        setTopMcatsCities({ mcat, cities });
        return;
      }
      if (fetchedGlid.current === glid) return;
      fetchedGlid.current = glid;
      setTopMcatsCities({ mcat: null, cities: null });
      (async () => {
        try {
          const [mcat, cities] = await Promise.all([
            displayCategoriesCities(1),
            displayCategoriesCities(2, true),
          ]);
          _paidCategoriesCache.set(glid, { mcat, cities });
          setTopMcatsCities({ mcat, cities });
        } catch (error) {
          console.log(error);
        }
      })();
    } else {
      if (_freeCategoriesCache.has(glid)) {
        const { productList: cachedList, count } = _freeCategoriesCache.get(glid);
        setProductList(cachedList);
        topProductsCount(count);
        return;
      }
      if (fetchedProductGlid.current === glid) return;
      fetchedProductGlid.current = glid;
      topProducts(glid);
    }
  }, [paidFree, glid]); // selectedTab intentionally excluded — API must not re-fire on tab change

  const displayData = (items, flag) =>
    items?.length > 0
      ? items.map(item => (flag === "mcats" ? item["glcat_mcat_name"] : item["city_name"])).join(", ")
      : "Not Available";

  return (
    <>
      {selectedTab === "8" &&
        (paidFree === "Paid | " ? (
          <>
            {topMcatsCities?.mcat && (
              <ListDisplay
                title="Top Categories"
                list={displayData(topMcatsCities?.mcat, "mcats")}
                onClick={redirectWeberpDIRIMPage}
              />
            )}
            {topMcatsCities?.cities && (
              <ListDisplay
                title="Preferred Cities"
                list={displayData(topMcatsCities?.cities, "cities")}
              />
            )}
          </>
        ) : (
          productList.length > 0 && (
            <ListDisplay
              title="Top Products"
              list={productList}
              onClick={redirectWeberpDIRIMPage}
            />
          )
        ))}

      {selectedTab === "7" && topProductsList.length > 0 && (
        <ListDisplay title="Top Categories" list={topProductsList} />
      )}
    </>
  );
};

export default TopCategories;